
$(document).ready(function() {
	let bookingForm = new BookingForm();
    bookingForm.init();
});

class BookingForm {
	init() {
		this.applyBindings();
	}

	applyBindings() {

		$('[data-action="event-booking-form"]').click( () => {
			this.submitBooking();
		});
	}

	submitBooking() {
		let form = $('#booking-form').serializeArray();
		let proceed = this.checkFormComplete();
		
		if (proceed) {
			let bookingId = $('[name="event_id"]').val();
			let url = window.feelbettr.custom_url ? window.feelbettr.baseUrl + '/events/attendee/' + window.feelbettr.profile + '/' + bookingId : window.feelbettr.baseUrl + '/events/attendee/' + bookingId;

			let previous_attendee = $('[data-id="previous_attendee"]').is(':checked') ? '1': '0';
			form.push({
				name: 'previous_attendee',
				value: previous_attendee
			})

			$('#booking-form').addClass('uk-hidden');
			$('#booking-spinner').removeClass('uk-hidden');
			$('#booking-form-warning').addClass('uk-hidden');

			$.ajaxSetup({
				headers: {
					'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
				}
			});

			// Reset form
			$.ajax({
				url: url,
				context: document.body,
				type: "POST",
				data: form,
				success: (result) => {
					if (result.success) {
						$('#booking-form-warning').removeClass('uk-hidden').find('.warning-text').text(result.message);
					} else {
						$('#booking-form-warning').removeClass('uk-hidden').find('.warning-text').text(result.message);
						$('#booking-form').removeClass('uk-hidden');
					}
					$('#booking-spinner').addClass('uk-hidden');
				},
				fail: () => {
					$('#booking-spinner').addClass('uk-hidden');
				}
			});
		} 
	}

	checkFormComplete() {
		let proceed = true;
		$('#booking-form').find('input, select, textarea').removeClass('uk-form-danger');
		$('#booking-form').find('input, select, textarea').each(function () {
			if ($(this).val() == "") {
				proceed = false;
				$(this).addClass('uk-form-danger');
			}
		});

		return proceed;

	}
}